// @greenlight-spec: decisions/0026-integration-catalog-and-connection-profiles.md
// @greenlight-spec: 09-data-brokering.md
/**
 * Axiom REST API token registration guide.
 *
 * Ingest and query go to the org's edge host; dataset and org management go to
 * api.axiom.co. API tokens are the only catalogued identity — PATs need an extra
 * org header and have full account control.
 */
export const AXIOM_API_TOKEN_STEPS = [
    {
        title: 'Choose the API domain this integration will call',
        body: 'Ingest and query use the org’s edge deployment: us-east-1.aws.edge.axiom.co (US East 1) or eu-central-1.aws.edge.axiom.co (EU Central 1). Find the default under Settings → General → Edge deployment.\n' +
            'Use api.axiom.co only when apps call dataset or org management APIs. Enter the host — not a URL — in Axiom API domain on this form.',
    },
    {
        title: 'Create an Advanced API token',
        body: 'In Axiom, open Settings → API tokens → New API token. Name it for this integration and prefer a dedicated token over sharing one across tools.\n' +
            'Choose Advanced, not Basic: a Basic token can only ingest. For apps that query APL/MPL, grant query on only the datasets they need; add ingest on those datasets if they also write events.',
    },
    {
        title: 'Cap query cost and copy the token once',
        body: 'Set hourly and daily query cost limits on the token — Axiom designed those caps for tokens given to AI agents. The token is shown once; paste it under Credentials on this form.\n' +
            'Do not use a personal access token. PATs have full account control and require an x-axiom-org-id header Greenlight does not inject on this profile.',
    },
];
//# sourceMappingURL=axiom-api-token-guide.js.map